import { gatewayFetch } from "@Auth/session";
import { gatewayUrl } from "@Constants/gatewayUrl";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import i18next from "i18next";
export const USAGE_LIMIT_ERROR = "usage-limit-reached";
const PAYMENT_REQUIRED = 402;
const processEvents = async (events)=>{
    await Word.run(async (context)=>{
        const headerRow = [
            [
                i18next.t("title"),
                i18next.t("workflows.TimelineCreate.columns.description"),
                i18next.t("workflows.TimelineCreate.columns.date")
            ]
        ];
        const dataRows = events.map((event)=>[
                event.title,
                event.description,
                event.date
            ]);
        const tableData = headerRow.concat(dataRows);
        const body = context.document.body;
        const table = body.insertTable(tableData.length, 3, Word.InsertLocation.end, tableData);
        table.select();
        table.style = "Normal";
        await context.sync();
    });
};
export const timelineCreateWorkflow = async ({ sections, token, signal, onProgress })=>{
    const url = `${gatewayUrl}/chats/createDocumentChrono`;
    const body = {
        sections: sections
    };
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };
    let eventList = [];
    let sectionsRead = 0;
    await fetchEventSource(url, {
        method: "POST",
        headers: {
            ...config.headers,
            Accept: "text/event-stream",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body),
        openWhenHidden: true,
        signal,
        fetch: gatewayFetch,
        async onopen (response) {
            if (response.status === PAYMENT_REQUIRED) throw new Error(USAGE_LIMIT_ERROR);
            if (!response.ok) throw new Error(`Timeline creation failed with status ${response.status}`);
        },
        onmessage (event) {
            if (!event.data.trim()) return;
            const events = JSON.parse(event.data);
            eventList = [
                ...eventList,
                ...events.events
            ];
            onProgress?.(++sectionsRead);
        },
        onerror (error) {
            throw error;
        }
    });
    if (signal?.aborted) return;
    await processEvents(eventList);
};
